import { useState, useEffect, useRef } from "react";
import { FormField } from '@prosolve/common-components-ui'
import useDataAccounts from '../dataHooks/useDataAccounts'

export default ({
  formData
}) => {

  const { fetchAccounts } = useDataAccounts()

  const [loading, setLoading] = useState(true);
  const [searchVal, setSearchVal] = useState('')
  const [accounts, setAccounts] = useState([])

  const fetchAccountsData = async () => {
    setLoading(true)
    try {
      const accountsData = await fetchAccounts(searchVal, true) || []
      setAccounts(accountsData)
    } catch (e) {
      console.log(e)
      setAccounts([])
    }
    setLoading(false)
  }

  const timeoutRef = useRef();
  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    timeoutRef.current = setTimeout(() => {
      fetchAccountsData();
    }, 500)
    setLoading(true)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchVal])

  const options = accounts.map(({ Id, Name }) => ({ value: Id, text: Name }))

  if (searchVal === '') {
    options.unshift({ value: '', text: '', display: 'All' })
  }

  return (
    <FormField
      style={{ flex: 1 }}
      width='100%'
      fieldId='accountId'
      type='search'
      label='District'
      formData={formData}
      options={options}
      suppressAutoClearOnFocus={true}
      isLoading={loading}
      onSearch={(val) => { setSearchVal(val) }}
      placeholder='All'
      maxHeight='200px'
    />
  )
}